import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function PopularFlightRoutesCard({
  title,
  imageSrc,
  destinations,
  content,
}) {
  const navigate = useNavigate();
  return (
    <div className="box_shadow grid grid-cols-[15%_85%] overflow-hidden rounded-lg border border-gray-200">
      <div>
        <img
          src={imageSrc}
          alt={title}
          className="h-full w-full object-cover"
        />
      </div>
      <div className="relative left-2 p-4 pr-0 text-sm">
        <h2 className="text-base font-bold">{title}</h2>
        <div className="flex flex-nowrap ">
          <ul className="flex cursor-pointer flex-wrap gap-x-6 gap-y-2 text-blue-500">
            {destinations.map((destination, index) => (
              <li
                key={index}
                className="list-disc transition duration-200 hover:text-blue-700 hover:underline"
                onClick={() =>
                  navigate(destination.url, {
                    state: { title: title, content: content },
                  })
                }
              >
                {destination.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
